import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "el-custom-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.store.recurring)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: $setup.store.cycle,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.cycle) = $event)),
          class: "w-100",
          placeholder: "Select Recurring Cycle"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.options, (opt, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: key,
                value: key,
                label: opt
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(opt), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]))
      : _createCommentVNode("v-if", true)
  ]))
}